module.exports = __webpack_public_path__ + "img/giftcard1.b03d76ad.png";